import { useTranslation } from 'react-i18next'
import { Form, Link, useNavigate } from 'react-router-dom'
import phoneShape from '../assets/phone-shape.webp'
import Button from '../components/Button'
import PageLayout from '../components/PageLayout'
import { useAppConfig } from '../contexts/AppConfigContext'

export default function LandingPage({
  appScreenshot: appScreenshotProp,
}: {
  /** @deprecated Use AppConfigProvider instead */
  appScreenshot?: string
} = {}) {
  const { appScreenshot: appScreenshotFromContext } = useAppConfig()
  const appScreenshot = appScreenshotProp ?? appScreenshotFromContext
  const { t } = useTranslation()
  const navigate = useNavigate()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    navigate('/onboarding')
  }

  return (
    <>
      <PageLayout withLogin fullWidth>
        <div className="grid h-full grid-cols-1 items-center gap-8 md:grid-cols-2 md:gap-16 md:px-16 lg:px-24">
          <div className="order-1 text-center md:order-none md:max-w-lg md:text-left">
            <h1
              className="text-[34px] leading-[1.1] font-bold tracking-tight md:text-[48px] lg:text-[56px]"
              data-testid="label-header"
            >
              {t('pages.landing.heading')}
            </h1>
            <p
              className="mt-5 text-[18px] leading-relaxed opacity-80 md:text-[24px]"
              data-testid="label-subheading"
            >
              {t('pages.landing.subheading')}
            </p>
            <Form method="post" onSubmit={onSubmit}>
              <Button
                className="mt-10 uppercase"
                title={t('buttons.startNow')}
                dataTestId="button-continue"
                type="submit"
              />
            </Form>
          </div>

          <div className="relative mx-auto aspect-[325/677] w-full max-w-[300px] md:max-w-[360px]">
            <div
              className="absolute inset-0 -z-10 scale-110 rounded-[40px] opacity-30 blur-3xl"
              style={{
                background:
                  'radial-gradient(circle, var(--color-primary) 0%, transparent 70%)',
              }}
            />
            <img
              src={phoneShape}
              className="absolute inset-0 z-0 h-full w-full object-contain drop-shadow-2xl"
              alt="Phone frame"
            />
            <div className="absolute inset-0 flex items-center justify-center overflow-hidden px-[13px] pt-[17px] pb-[15px]">
              <img
                src={appScreenshot}
                className="z-10 h-full w-full object-contain"
                alt="App screenshot"
              />
            </div>
          </div>
        </div>
      </PageLayout>

      <footer className="px-6 py-6">
        <div className="flex flex-wrap items-center justify-center gap-x-3 text-base text-[#BBBFCB]">
          <Link
            to="https://app-studio.ai/terms"
            className="transition-colors hover:text-gray-800"
          >
            {t('footer.terms')}
          </Link>
          <span className="opacity-40">·</span>
          <Link
            to="https://app-studio.ai/privacy"
            className="transition-colors hover:text-gray-800"
          >
            {t('footer.privacy')}
          </Link>
          <span className="opacity-40">·</span>
          <Link
            to="/help-center/contact"
            className="transition-colors hover:text-gray-800"
          >
            {t('footer.contact', { defaultValue: 'Contact' })}
          </Link>
          <span className="opacity-40">·</span>
          <Link
            to="/help-center/cancel-subscription"
            className="transition-colors hover:text-gray-800"
          >
            {t('footer.cancelSubscription', {
              defaultValue: 'How to Cancel Subscription',
            })}
          </Link>
        </div>
      </footer>
    </>
  )
}
